import React from "react";
import Navbar from "../component/Navbar";
import TodoImages from "../component/TodoImages";
import Footer from "../component/Footer";

function ThingsToDo() {
	return (
		<div>
			<Navbar />
			<div
				className="container" 
				id="things-to-do"
			>
				<h2 className="text-center mt-5">Things to do</h2>
				<div className="row mt-5">
					<div className="col-sm-6 d-flex">
						<img
							className="img-fluid"
							src="https://s3.amazonaws.com/shecodesio-production/uploads/files/000/081/783/original/blue_dome.jpg?1684019856"
							alt="Blue Dome Church"
						/>
					</div>

					<div className="col-sm-6">
						<h3 className="mb-3">Sunset in Oia</h3>
						<p>
							One of the most iconic places to visit, this beautiful cliff-top
							town is perfect for admiring the sunset. This popular spot can be
							very crowded but who can blame others for wanting such a gorgeous
							view!
						</p>
						<br />
						<h3 className="mb-3">Hike from Fira to Oia</h3>
						<p>
							This hike follows the Caldera trail and allows you to soak in the
							beautiful views of the island. Remember to pack some comfy shoes!
						</p>

						<h3 className="mb-3">Visit the many churches</h3>
						<p>
							Santorini has an abundance of churches to offer - 450 to be exact!
							From the infamous blue domed church to others such as Anastasi
							Church; Panagia Mesiani Church; Santorini Catholic Cathedral; St
							John the Theologian Church. Oh, and of course the IG worthy Three
							Bells of Fira.
						</p>

						<h3 className="mb-3">Red Beach</h3>
						<p>
							If you're looking to relax for a few hours then head to this
							stunning beach. The beach is surrounded by volcanic rocks and red
							sand composing of black and red pulverized volcanic rock.
						</p>
					</div>
				</div>
			</div>

			<div className="santorini-images mt-5">
				<div className="container images d-flex justify-content-around">
					<TodoImages />
				</div>
			</div>
			<Footer />
		</div>
	);
}

export default ThingsToDo;
